import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const _dropdownMenuItemBaseVariants = tv({
  base: `
    relative flex items-center gap-2 rtl:dir-rtl py-1.5 text-sm outline-hidden select-none rounded-sm cursor-default
    data-[disabled]:pointer-events-none data-[disabled]:opacity-60
    [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4
  `
}), dropdownMenuOperateItemVariants = tv({
  extend: _dropdownMenuItemBaseVariants,
  base: "pe-2 ps-8 focus:bg-(--gray-tag-1) dark:focus:bg-(--gray-tag-2) focus:text-(--gray-text-2)",
  slots: {
    iconBox: "absolute start-2 flex size-3.5 items-center justify-center pointer-events-none"
  }
}), dropdownMenuItemVariants = tv({
  extend: _dropdownMenuItemBaseVariants,
  base: "px-2 text-sm outline-hidden select-none cursor-default data-[inset]:pl-8 [&_svg:not([class*='text-'])]:text-(--gray-primary-1)",
  variants: {
    isSelected: {
      true: "bg-(--primary-2) text-(--white) dark:text-(--gray-text-2)",
      false: "focus:bg-(--gray-tag-1) dark:focus:bg-(--gray-tag-2) focus:text-(--gray-text-2)"
    },
    variant: {
      default: void 0,
      destructive: `
                   data-[variant=destructive]:text-(--red-9)
             focus:data-[variant=destructive]:bg-(--red-3-alpha)
        dark:focus:data-[variant=destructive]:bg-(--red-6-alpha)
             focus:data-[variant=destructive]:text-(--red-9)
                   data-[variant=destructive]:*:[svg]:!text-(--red-9)
      `
    }
  },
  defaultVariants: {
    isSelected: !1,
    variant: "default"
  }
}), _dropdownMenuContentBaseVariants = tv({
  base: `
    z-50 min-w-[8rem] border p-1 rounded-md
    bg-(--white) dark:bg-(--gray-bg-2) text-(--gray-text-2) origin-(--reka-dropdown-menu-content-transform-origin)
    data-[state=open]:animate-in    data-[state=open]:fade-in-0     data-[state=open]:zoom-in-95
    data-[state=closed]:animate-out data-[state=closed]:fade-out-0  data-[state=closed]:zoom-out-95
       data-[side=top]:slide-in-from-bottom-2
     data-[side=right]:slide-in-from-left-2
    data-[side=bottom]:slide-in-from-top-2
      data-[side=left]:slide-in-from-right-2
  `
}), dropdownMenuContentVariants = tv({
  extend: _dropdownMenuContentBaseVariants,
  base: "overflow-x-hidden overflow-y-auto shadow-md"
}), dropdownMenuSubContentVariants = tv({
  extend: _dropdownMenuContentBaseVariants,
  base: "overflow-hidden shadow-lg"
});
export {
  _dropdownMenuContentBaseVariants,
  dropdownMenuContentVariants,
  dropdownMenuItemVariants,
  dropdownMenuOperateItemVariants,
  dropdownMenuSubContentVariants
};
//# sourceMappingURL=index.js.map
